import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

// Modify the thunk to accept search parameters for name, startDate, and endDate
export const homeBannerApi = createAsyncThunk("homeBanner", async () => {
  const response = await axiosInstance.get(`/homebanner_get`);
  return response.data;
});

const homeBannerSlice = createSlice({
  name: "homeBanner",
  initialState: {
    homeBanner: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(homeBannerApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(homeBannerApi.fulfilled, (state, action) => {
        state.homeBanner = action.payload;
        state.loading = false;
      })
      .addCase(homeBannerApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default homeBannerSlice.reducer;
